import { deeplinkUrl } from './url'
import { deeplinkMShopAndroid, deeplinkMshopIos } from './mshop'
import {
  deeplinkWin10Edge,
  deeplinkWin10Firefox,
  deeplinkWin10FirefoxLegacy,
  deeplinkWin10Chrome,
} from './win10'
import { ClientsideLogger } from '@utils'

const logger = new ClientsideLogger('DVWebNode:deeplink')
const COUNTER_PREFIX = 'DVWebNode:deeplinking'
export type DeeplinkHandlerInput = { url: string; fallbackUrl?: string }
export type LogInput = { isSuccess: boolean }
export type DeeplinkHandlerLogInput = {
  logOutcome: (input: LogInput) => void
}

const log = (
  fn: (input: DeeplinkHandlerLogInput) => (input: DeeplinkHandlerInput) => void,
  variant: string
) => {
  return fn({
    logOutcome: ({ isSuccess }: LogInput) => {
      logger.count(
        `${COUNTER_PREFIX}:${variant}:${isSuccess ? 'success' : 'failure'}`,
        1,
        true
      )
    },
  })
}

export const processDeeplinkFor = {
  URL: log(deeplinkUrl, 'url'),
  MSHOP_ANDROID: log(deeplinkMShopAndroid, 'mshopAndroid'),
  MSHOP_IOS: log(deeplinkMshopIos, 'mshopIos'),
  IOS_LEGACY: log(deeplinkUrl, 'iosLegacy'),
  WIN10_EDGE: log(deeplinkWin10Edge, 'win10Edge'),
  WIN10_FIREFOX: log(deeplinkWin10Firefox, 'win10Firefox'),
  WIN10_FIREFOX_LEGACY: log(deeplinkWin10FirefoxLegacy, 'win10FirefoxLegacy'),
  WIN10_CHROME: log(deeplinkWin10Chrome, 'win10Chrome'),
}
